import React, { useState, useEffect, useContext } from 'react'

import styles from './Contratante.module.css'

//Componentes
import ContratanteNatural from '../../components/ContratanteNatural'
import ContratanteJuridico from '../../components/ContratanteJuridico'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import SubMenu from '../../components/SubMenu'
import Modal from '../../components/Modals'

//Utiles
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'
import * as Funciones from '../../utils/funciones'
import * as Constantes from '../../utils/constantes'

import * as ContratanteRepository from "../../services/repositories/contratante-repository";

const Contratante = ({ history }) => {
    const initialState = {
        estaCargando: true,
        errorCargando: null,
        contratante: null,
        distritosEcommerce: [],
        textoError: [],
        reloadValidacion: false,
        campoValidado: {
            //Identificacion
            tipoDocumento: true,
            numeroDocumento: true,
            numeroRUC: true,
            //Contacto
            celular: true,
            email: true,
            distrito: true,
            direccion: true,
            //Datos Personales
            nombres: true,
            apellidoPaterno: true,
            apellidoMaterno: true,
            sexo: true,
            nacionalidad: true,
            fechaNacimiento: true,
            estadoCivil: true,
            vinculo: true,
            //Laboral
            empleadorEmpresa: true,
            giro: true,
            cargo: true,
            ocupacion: true,
            tipoLabores: true,
            ingresoAnual: true,
            //Empresa
            razonSocial: true,
            giroEmpresa: true,
            ingresoAnualEmpresa: true,
            //RepresentanteLegal
            nombresRL: true,
            apellidoPaternoRL: true,
            apellidoMaternoRL: true,
            tipoDocumentoRL: true,
            numeroDocumentoRL: true,
            //Gerente Administrativo
            nombresGA: true,
            apellidoPaternoGA: true,
            apellidoMaternoGA: true,
            tipoDocumentoGA: true,
            numeroDocumentoGA: true,
            //Subpregunta1
            NIT1: true,
            //Subpregunta2
            pais: [],
            NIT: [],
            noTieneNIT: true,
            noTieneNITDesc: true
        },
        modalTamanio: false,
        activaLlamado: false,
        noBloqueo: false,
        subPreguntas: [],
        detalle1: {
            NIT: null
        },
        detalle2: [
            {
                pais: null,
                NIT: null
            }
        ],
        noTieneNIT: 0,
        noTieneNITDesc: null
    }

    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    let photo = generalState.photos.contratante
    //asrivera: variables para obtener la extencion de la imagen frontal y posterior
    let pruebaPhotoFrontal = (photo.frontal).split(";", 1)
    let pruebaPhoto2Frontal = pruebaPhotoFrontal[0].split("/", 2)
    let pruebaPhotoPosterior = (photo.posterior).split(";", 1)
    let pruebaPhoto2Posterior = pruebaPhotoPosterior[0].split("/", 2)
    const textos = [
        'Importante',
        'Debes responder la(s) pregunta(s) en la sección "Adicional"'
    ]

    const [mostrarModal, setModal] = useState(false)
    const [mostrarModal2, setModal2] = useState(false)

    const [cambia, setCambia] = useState(false)
    const ocultaMensaje = () => {
        setCambia(!cambia)
    }

    const [state, setState] = useState(initialState)

    const [mostrarMensajes, setMostrarMensajes] = useState(false)
    const [mensajes, setMensajes] = useState([])

    const mostrarPopup = () => {
        setModal(!mostrarModal)
    }

    const armarDetalleSubpreguntas = (subrespuestas) => {
        if (subrespuestas.length !== 0) {
            let detail1 = null
            let detail2 = []
            let noNit = null
            let noNitDesc = null
    
            subrespuestas.map(subrespuesta => {
                if (subrespuesta.idBancoPregunta === 57 || subrespuesta.idBancoPregunta === 59) {
                    if (subrespuesta.respuesta === 1) {
                        let nuevo = JSON.parse(subrespuesta.detalle[0].valor)
                        detail1 = {
                            NIT: nuevo[0].valor
                        }
                    } else {
                        detail1 = null
                    }
                }
    
                if (subrespuesta.idBancoPregunta === 58 || subrespuesta.idBancoPregunta === 60) {
                    if (subrespuesta.respuesta === 1) {
                        let dets = subrespuesta.detalle.map(det => {
                            return JSON.parse(det.valor)
                        })
                
                        let nuevo = dets.map(det => {
                            return det.reduce(function(a, c) {
                                if (c.campo === 'pais' || c.campo === 'NIT') {
                                    a[c.campo] = c.valor
                                } else {
                                    if (c.campo === 'noTieneNIT') noNit = c.valor
                                    else if (c.campo === 'noTieneNITDesc') noNitDesc = c.valor
                                }
                                return a
                            }, {})
                        })
                        detail2 = nuevo
                    } else {
                        detail2 = null
                    }
                }
            })
    
            return {
                det1: detail1,
                det2: detail2,
                det3: noNit,
                det4: noNitDesc
            }
        } else {
            return {
                det1: null,
                det2: null,
                det3: null,
                det4: null
            }
        }
    }

    const cargarDatosIniciales = async () => {
        const cargarContratante = async () => {
            const response = await ContratanteRepository.obtenerContratante(cotizacion.idSolicitudMultiple)
            if(response.error === null) {
                if (response.contratante !== null && response.contratante.idContratante !== null) {
                    let detalles = armarDetalleSubpreguntas(response.contratante.subRespuestas)
                    setState((state) => {
                        return {
                            ...state,
                            contratante: {
                                ...response.contratante,
                                idSolicitudMultiple: cotizacion.idSolicitudMultiple,
                                tipoPersona: {
                                    codigo: cotizacion.asegurado.tipoPersona.codigo
                                },
                            },
                            activaLlamado: true,
                            detalle1: detalles.det1 !== null ? detalles.det1 : state.detalle1,
                            detalle2: detalles.det2 !== null ? detalles.det2 : state.detalle2,
                            noTieneNIT: detalles.det3 !== null ? detalles.det3 : state.noTieneNIT,
                            noTieneNITDesc: detalles.det4 !== null ? detalles.det4 : state.noTieneNITDesc
                        }
                    })
                } else {
                    let contratanteAux = null
                    if (cotizacion.asegurado.tipoPersona.codigo === 2) {
                        contratanteAux = {
                            tipoPersona: {
                                codigo: cotizacion.asegurado.tipoPersona.codigo
                            },
                            idSolicitudMultiple: cotizacion.idSolicitudMultiple,
                            empresa: {},
                            representanteLegal: {},
                            gerenteAdministrativo: {},
                            respuestas: []
                        }
                    } else if (cotizacion.asegurado.tipoPersona.codigo === 1) {
                        contratanteAux = {
                            tipoPersona: {
                                codigo: cotizacion.asegurado.tipoPersona.codigo
                            },
                            idSolicitudMultiple: cotizacion.idSolicitudMultiple,
                            laboral: {},
                            subRespuestas: []
                        }
                    }

                    setState((state) => {
                        return {
                            ...state,
                            contratante: contratanteAux,
                            activaLlamado: true
                        }
                    })
                }
            } else {
                //if (response.error.codigoRespuesta === 401) {
                    generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
                //}
            }
        }

        /**Se invoca al servicio de GET contratantes cada vez que se ingrese a la pantalla */
        /**para que, en caso el servicio de POST falle y se guarden los datos del contratante, */
        /**no se vuelva a llamar al POST sino al PUT*/
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await cargarContratante()
        generalDispatch(GeneralActions.updateEstadoCargando(false))
    }

    useEffect(() => {
        cargarDatosIniciales()
    }, [])

    const validarPantalla = async () => {
        let validado = true
        const asignarValidacionCampo = (campo, valor, index) => {
            validado = validado && valor
            if (index === undefined) {
                setState((state) => {
                    return {
                        ...state,
                        campoValidado: {
                            ...state.campoValidado,
                            [campo]: valor
                        }
                    }
                })
            } else {
                let campoValidacion = state.campoValidado[campo]
                campoValidacion[index] = valor
                setState((state) => {
                    return {
                        ...state,
                        campoValidado: {
                            ...state.campoValidado,
                            [campo]: campoValidacion
                        }
                    }
                })
            }
        }

        const invocarGuardarContratante = async () => {

            let contratanteAux = {}
            if (cotizacion.asegurado.tipoPersona.codigo === 1) {
                let newRespuesta = null
                /**[INICIO] - Conversiones para guardar los detalles de las subpreguntas de contratante natural */
                if (cotizacion.flagDeclaJurada) {
                    let pregunta = state.contratante.respuestas.find(r => r.idBancoPregunta === 14 || r.idBancoPregunta === 52)
                    if (pregunta !== undefined && pregunta.respuesta === 1) {
                        let subRptas = state.contratante.subRespuestas.map(sub => {
                            if (sub.respuesta === 1) {
                                if (sub.idBancoPregunta === 57 || sub.idBancoPregunta === 59) {
                                    let arrayV1 = []
                                    let pasarToStr1 = {
                                        valor: JSON.stringify(arrayV1.concat({
                                            campo: 'NIT',
                                            valor: state.detalle1.NIT  
                                        }))
                                    }
                                    let nuevo = []
                                    sub.detalle = nuevo.concat(pasarToStr1)
                                } else if (sub.idBancoPregunta === 58 || sub.idBancoPregunta === 60) {
                                    let detalles = state.detalle2.map(det => {
                                        let arrays = []
                                        let names = Object.keys(det).concat(['noTieneNIT', 'noTieneNITDesc'])
                                        let values = Object.values(det).concat([state.noTieneNIT, state.noTieneNITDesc])
                                        for (let i = 0; i < names.length; i++) {
                                            arrays.push({
                                                campo: names[i],
                                                valor: values[i]
                                            })
                                        }
                                        return {
                                            valor: JSON.stringify(arrays)
                                        }
                                    })
                                    sub.detalle = detalles
                                }
                            }
                            return sub
                        })
                    }
                } else {
                    let pregunta = cotizacion.preguntas.filter(p => p.idBancoPregunta === 14 || p.idBancoPregunta === 52)[0]
                    let respuesta = [
                        {
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: 0
                        }
                    ]
                    newRespuesta = respuesta
                }
                /**[FIN] - Conversiones para guardar los detalles de las subpreguntas de contratante natural */
                contratanteAux = {
                    ...state.contratante,
                    usuario: user.info.IdUsuario,
                    contacto: {
                        ...state.contratante.contacto,
                        celular: state.contratante.contacto.celular.toString(),
                        tipoDireccion: {//Tipo de Dirección por Defecto
                            codigo: state.contratante.tipoPersona.codigo,
                            descripcion: 'Comercial'
                        },
                    },
                    laboral: {
                        ...state.contratante.laboral,
                        ingresoAnual: Funciones.cantidadStringToFloat(state.contratante.laboral.ingresoAnual)
                    },
                    respuestas: cotizacion.flagDeclaJurada ? state.contratante.respuestas : newRespuesta
                }
            } else if (cotizacion.asegurado.tipoPersona.codigo === 2) {
                contratanteAux = {
                    ...state.contratante,
                    usuario: user.info.IdUsuario,
                    contacto: {
                        ...state.contratante.contacto,
                        celular: state.contratante.contacto.celular.toString(),
                        tipoDireccion: {//Tipo de Dirección por Defecto
                            codigo: state.contratante.tipoPersona.codigo,
                            descripcion: 'Comercial'
                        },
                    },
                    empresa: {
                        ...state.contratante.empresa,
                        ingresoAnual: Funciones.cantidadStringToFloat(state.contratante.empresa.ingresoAnual),
                        razonSocial: state.contratante.empresa.razonSocial.trim()
                    }
                }
            }

            const response = await ContratanteRepository.guardarContratante(contratanteAux)
            if(response.error === null) {
                if (!state.noBloqueo) {
                    if (response.contratante.mensaje === "") {
                        generalDispatch(GeneralActions.setContratanteCotizacion({
                            ...contratanteAux,
                        }))
                        return true
                    } else {
                        setMensajes(['¡Alerta!', response.contratante.mensaje])
                        setMostrarMensajes(true)
                        setState((state) => {
                            return {
                                ...state,
                                contratante: {
                                    ...state.contratante,
                                    idContratante: response.contratante.idContratante
                                },
                                noBloqueo: true
                            }
                        })
                        return false
                    }
                } else {
                    generalDispatch(GeneralActions.setContratanteCotizacion({
                        ...contratanteAux,
                    }))
                    return true
                }
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
                return false
            }
        }

        const validarCombo = (objeto, campoValidacion, campo, index) => {
            if (objeto === undefined || objeto === null || objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo].codigo === null ||
                objeto[campo].codigo === 0 ||
                objeto[campo] === '0') {
                asignarValidacionCampo(campoValidacion, false, index)
            } else {
                asignarValidacionCampo(campoValidacion, true, index)
            }
        }

        const validarTexto = (objeto, campoValidacion, campo, index) => {
            if (campoValidacion === 'ingresoAnual') {
                if (objeto !== null && isNaN(objeto[campo])) {
                    asignarValidacionCampo(campoValidacion, false)
                }
            } else if (objeto === undefined || objeto === null || objeto[campo] === undefined ||
                objeto[campo] === null || objeto[campo] === '') {
                asignarValidacionCampo(campoValidacion, false, index)
            } else {
                asignarValidacionCampo(campoValidacion, true, index)
            }
        }

        const validarCorreo = (objeto, campoValidacion, campo) => {
            let correo = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if (objeto === undefined || objeto === null || objeto[campo] === undefined ||
                objeto[campo] === '' || !objeto[campo].match(correo)) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarNumero = (objeto, campoValidacion, campo) => {
            if (objeto === undefined || objeto === null ||
                objeto[campo] === null ||
                objeto[campo] === undefined ||
                objeto[campo] === '' ||
                objeto[campo] === '0' || isNaN(objeto[campo])) {
                asignarValidacionCampo(campoValidacion, false)
            } else {
                asignarValidacionCampo(campoValidacion, true)
            }
        }

        const validarPantallaNatural = () => {
            //Identificacion Natural
            validarCombo(state.contratante, 'tipoDocumento', 'tipoDocumento')

            if (state.contratante.tipoDocumento === undefined || state.contratante.tipoDocumento === null) {
                asignarValidacionCampo('numeroDocumento', false)
            } else if (state.contratante.tipoDocumento.codigo === 1 || state.contratante.tipoDocumento.codigo === 4) {
                if (state.contratante.numeroDocumento === '' || state.contratante.numeroDocumento.match(/[01]{8,}/) ||
                    state.contratante.numeroDocumento.match(/12345678.*/)) {
                    asignarValidacionCampo('numeroDocumento', false)
                } else {
                    asignarValidacionCampo('numeroDocumento', true)
                }
            } else if (state.contratante.tipoDocumento.codigo === 3) {
                if (state.contratante.numeroDocumento.match(/[01]{12}/)) {
                    asignarValidacionCampo('numeroDocumento', false)
                } else {
                    asignarValidacionCampo('numeroDocumento', true)
                }
            }
            //Contacto Natural
            validarNumero(state.contratante.contacto, 'celular', 'celular')
            if (state.contratante.contacto === undefined || state.contratante.contacto === null
                || state.contratante.contacto.celular === undefined
                || state.contratante.contacto.celular === null
                || state.contratante.contacto.celular === ''
                || state.contratante.contacto.celular.toString().length !== 9) {
                asignarValidacionCampo('celular', false)
            } else {
                asignarValidacionCampo('celular', true)
            }
            validarCorreo(state.contratante.contacto, 'email', 'email')
            if (state.contratante.contacto !== undefined) {
                if (state.contratante.contacto.email === cotizacion.asegurado.contacto.email) {
                    asignarValidacionCampo('emailRepetido', false)
                } else {
                    asignarValidacionCampo('emailRepetido', true)
                }
            }
            validarTexto(state.contratante.contacto, 'distrito', 'distrito')
            validarTexto(state.contratante.contacto, 'direccion', 'direccion')
            //Datos Personales
            validarTexto(state.contratante, 'nombres', 'nombres')
            validarTexto(state.contratante, 'apellidoPaterno', 'apellidoPaterno')
            validarTexto(state.contratante, 'apellidoMaterno', 'apellidoMaterno')
            if (state.contratante.sexo === null || state.contratante.sexo === undefined || state.contratante.sexo.codigo === null
                || state.contratante.sexo.codigo === '') {
                asignarValidacionCampo('sexo', false)
            } else {
                asignarValidacionCampo('sexo', true)
            }
            if (!state.contratante.fechaNacimiento || state.contratante.fechaNacimiento === null) { asignarValidacionCampo('fechaNacimiento', false) }
            else { asignarValidacionCampo('fechaNacimiento', true) }
            validarCombo(state.contratante, 'nacionalidad', 'nacionalidad')
            validarCombo(state.contratante, 'estadoCivil', 'estadoCivil')
            validarCombo(state.contratante, 'vinculo', 'vinculo')
            //Laboral
            validarTexto(state.contratante.laboral, 'empleadorEmpresa', 'empleadorEmpresa')
            validarCombo(state.contratante.laboral, 'giro', 'giro')
            validarCombo(state.contratante.laboral, 'cargo', 'cargo')
            validarCombo(state.contratante.laboral, 'ocupacion', 'ocupacion')
            validarCombo(state.contratante.laboral, 'tipoLabores', 'tipoLabores')
            validarTexto(state.contratante.laboral, 'ingresoAnual', 'ingresoAnual')

            if (cotizacion.flagDeclaJurada) {
                if (!state.contratante.respuestas) {
                    mostrarPopup()
                    validado = false
                } else {
                    let pregunta = state.contratante.respuestas[0]
                    if (pregunta !== undefined && pregunta.respuesta === 1) {
                        if (state.contratante.subRespuestas.length !== 2) {
                            setMensajes(['Importante', 'Debe responder la(s) subpregunta(s) en la sección "Adicional"'])
                            setMostrarMensajes(true)
                            validado = false
                        } else {
                            let pregunta1 = state.contratante.subRespuestas.find(s => s.idBancoPregunta === 57 || s.idBancoPregunta === 59)
                            let pregunta2 = state.contratante.subRespuestas.find(s => s.idBancoPregunta === 58 || s.idBancoPregunta === 60)
    
                            if (pregunta1.respuesta === 1) {
                                if (state.detalle1.NIT === null || state.detalle1.NIT === '')
                                    asignarValidacionCampo('NIT1', false)
                            }
    
                            if (pregunta2.respuesta === 1) {
                                state.detalle2.map((det2, index) => {
                                    validarCombo(det2, 'pais', 'pais', index)
                                    if (det2.NIT === null || det2.NIT === '') {
                                        if (state.noTieneNIT === 0) {
                                            asignarValidacionCampo('noTieneNIT', false)
                                        } else {
                                            if (state.noTieneNIT === 2) {
                                                validarTexto(state, 'noTieneNITDesc', 'noTieneNITDesc')
                                            }
                                        }
                                    }
                                    return det2
                                })
                            }
                        }
                    }
                }
            }
        }

        const validarPantallaJuridico = () => {
            //Contacto Juridico
            validarNumero(state.contratante.contacto, 'celular', 'celular')
            if (state.contratante.contacto === undefined || state.contratante.contacto === null
                || state.contratante.contacto.celular === undefined
                || state.contratante.contacto.celular === null
                || state.contratante.contacto.celular === ''
                || state.contratante.contacto.celular.toString().length !== 9) {
                asignarValidacionCampo('celular', false)
            } else {
                asignarValidacionCampo('celular', true)
            }
            validarCorreo(state.contratante.contacto, 'email', 'email')
            validarTexto(state.contratante.contacto, 'distrito', 'distrito')
            validarTexto(state.contratante.contacto, 'direccion', 'direccion')
            //Empresa
            validarTexto(state.contratante.empresa, 'razonSocial', 'razonSocial')
            validarCombo(state.contratante.empresa, 'giroEmpresa', 'giro')
            validarNumero(state.contratante.empresa, 'ingresoAnualEmpresa', 'ingresoAnual')
            validarTexto(state.contratante, 'numeroRUC', 'numeroDocumento')
            //Representante Legal
            validarTexto(state.contratante.representanteLegal, 'nombresRL', 'nombres')
            validarTexto(state.contratante.representanteLegal, 'apellidoPaternoRL', 'apellidoPaterno')
            if (state.contratante.representanteLegal === undefined || state.contratante.representanteLegal === null || state.contratante.representanteLegal.tipoDocumento === undefined
                || state.contratante.representanteLegal.tipoDocumento === null || state.contratante.representanteLegal.tipoDocumento === ''
                || state.contratante.representanteLegal.tipoDocumento.codigo === 0) {
                asignarValidacionCampo('numeroDocumentoRL', false)
                asignarValidacionCampo('tipoDocumentoRL', false)
                validarTexto(state.contratante.representanteLegal, 'apellidoMaternoRL', 'apellidoMaterno')
            } else if (state.contratante.representanteLegal === undefined || state.contratante.representanteLegal === null || state.contratante.representanteLegal.tipoDocumento === undefined
                || state.contratante.representanteLegal.tipoDocumento === null || (state.contratante.representanteLegal.tipoDocumento.codigo === 1 || state.contratante.representanteLegal.tipoDocumento.codigo === 4)) {
                if (state.contratante.representanteLegal.numeroDocumento === null || state.contratante.representanteLegal.numeroDocumento === undefined
                    || state.contratante.representanteLegal.numeroDocumento.match(/[01]{8,}/)
                    || state.contratante.representanteLegal.numeroDocumento.match(/12345678.*/)
                    || state.contratante.representanteLegal.numeroDocumento === '') {
                    asignarValidacionCampo('numeroDocumentoRL', false)
                } else {
                    asignarValidacionCampo('numeroDocumentoRL', true)
                }
                validarTexto(state.contratante.representanteLegal, 'apellidoMaternoRL', 'apellidoMaterno')
                asignarValidacionCampo('tipoDocumentoRL', true)
            } else if (state.contratante.representanteLegal === undefined || state.contratante.representanteLegal === null || state.contratante.representanteLegal.tipoDocumento === undefined
                || state.contratante.representanteLegal.tipoDocumento === null || state.contratante.representanteLegal.tipoDocumento.codigo === 3) {
                if (state.contratante.representanteLegal.numeroDocumento === null || state.contratante.representanteLegal.numeroDocumento === undefined
                    || state.contratante.representanteLegal.numeroDocumento.match(/[01]{12}/)
                    || state.contratante.representanteLegal.numeroDocumento === '') {
                    asignarValidacionCampo('numeroDocumentoRL', false)
                } else {
                    asignarValidacionCampo('numeroDocumentoRL', true)
                }
                asignarValidacionCampo('apellidoMaternoRL', true)
                asignarValidacionCampo('tipoDocumentoRL', true)
            } else {
                asignarValidacionCampo('tipoDocumentoRL', true)
            }
            //Gerente Administrativo
            validarTexto(state.contratante.gerenteAdministrativo, 'nombresGA', 'nombres')
            validarTexto(state.contratante.gerenteAdministrativo, 'apellidoPaternoGA', 'apellidoPaterno')
            if (state.contratante.gerenteAdministrativo === undefined || state.contratante.gerenteAdministrativo === null || state.contratante.gerenteAdministrativo.tipoDocumento === undefined
                || state.contratante.gerenteAdministrativo.tipoDocumento === null || state.contratante.gerenteAdministrativo.tipoDocumento === ''
                || state.contratante.gerenteAdministrativo.tipoDocumento.codigo === 0) {
                asignarValidacionCampo('numeroDocumentoGA', false)
                asignarValidacionCampo('tipoDocumentoGA', false)
                validarTexto(state.contratante.gerenteAdministrativo, 'apellidoMaternoGA', 'apellidoMaterno')
            } else if (state.contratante.gerenteAdministrativo === undefined || state.contratante.gerenteAdministrativo === null || state.contratante.gerenteAdministrativo.tipoDocumento === undefined
                || state.contratante.gerenteAdministrativo.tipoDocumento === null || (state.contratante.gerenteAdministrativo.tipoDocumento.codigo === 1 || state.contratante.gerenteAdministrativo.tipoDocumento.codigo === 4)) {
                if (state.contratante.gerenteAdministrativo.numeroDocumento === null || state.contratante.gerenteAdministrativo.numeroDocumento === undefined
                    || state.contratante.gerenteAdministrativo.numeroDocumento.match(/[01]{8,}/)
                    || state.contratante.gerenteAdministrativo.numeroDocumento.match(/12345678.*/)
                    || state.contratante.gerenteAdministrativo.numeroDocumento === '') {
                    asignarValidacionCampo('numeroDocumentoGA', false)
                } else {
                    asignarValidacionCampo('numeroDocumentoGA', true)
                }
                validarTexto(state.contratante.gerenteAdministrativo, 'apellidoMaternoGA', 'apellidoMaterno')
                asignarValidacionCampo('tipoDocumentoGA', true)
            } else if (state.contratante.gerenteAdministrativo === undefined || state.contratante.gerenteAdministrativo === null || state.contratante.gerenteAdministrativo.tipoDocumento === undefined
                || state.contratante.gerenteAdministrativo.tipoDocumento === null || state.contratante.gerenteAdministrativo.tipoDocumento.codigo === 3) {
                if (state.contratante.gerenteAdministrativo.numeroDocumento === null || state.contratante.gerenteAdministrativo.numeroDocumento === undefined
                    || state.contratante.gerenteAdministrativo.numeroDocumento.match(/[01]{12}/)
                    || state.contratante.gerenteAdministrativo.numeroDocumento === '') {
                    asignarValidacionCampo('numeroDocumentoGA', false)
                } else {
                    asignarValidacionCampo('numeroDocumentoGA', true)
                }
                asignarValidacionCampo('apellidoMaternoGA', true)
                asignarValidacionCampo('tipoDocumentoGA', true)
            } else {
                asignarValidacionCampo('tipoDocumentoGA', true)
            }
        }

        if (state.contratante.tipoPersona.codigo === 1) {
            validarPantallaNatural()
        } else if (state.contratante.tipoPersona.codigo === 2) {
            validarPantallaJuridico()
        }

        //Invocar Servicio Post/Put Contratante
        if (validado) {
            return invocarGuardarContratante()
        } else {
            return false
        }
    }

    const [mover, setMover] = useState(false)
    const mueveContenido = (valor) => {
        setMover(valor)
    }

    const [mostrarModal3, setModal3] = useState(false)
    const textos2 = [
        '¡Alerta!',
        'No se ubica el nro. de documento en la BD de Personas'
    ]

    const mostrarPopup2 = () => {
        setModal3(!mostrarModal3)
    }

    return (
        <React.Fragment>
            <Header history={history} />
            <SubMenu history={history} modal={mostrarModal || state.estaCargando || mostrarModal3 || state.modalTamanio}
                desplaza={mueveContenido} />
            <section className={styles['areadatosusuario']}
                style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}}
            >
                {cotizacion.asegurado && cotizacion.asegurado.tipoPersona.codigo === 1 && state.contratante
                    ? <ContratanteNatural
                        contratante={state.contratante}
                        state={state}
                        setState={setState}
                        respuesta={state.respuesta}
                        modal={mostrarPopup2}
                    />
                    : null
                }

                {cotizacion.asegurado && cotizacion.asegurado.tipoPersona.codigo === 2 && state.contratante
                    ? <ContratanteJuridico
                        contratante={state.contratante}
                        state={state}
                        setState={setState} />
                    : null
                }

                <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos} />
                <Modal mostrarModal={mostrarModal3} setModal={setModal3} textos={textos2} />
                <Modal mostrarModal={mostrarMensajes} setModal={setMostrarMensajes} textos={mensajes} estilos={{whiteSpace: 'break-spaces'}} />
                <Footer history={history} validarPantalla={validarPantalla} />
            </section>
        </React.Fragment>
    )
}

export default Contratante